export default __webpack_public_path__ + "static/media/variety.5df9c47e.svg";